import React from 'react'

import { ZariContext } from '_zari/context'

import { Button, Col, Row, Table, Portlet } from '_zari/core'

import EstadosTurnosConstant from 'constants/estadosTurnos'

import { DateHandler, DownloadAxiosFile } from 'utils'

import FechaFiltroFormGroup from './formGroups/fechaFiltro'
import IdUsuarioFormGroup from './formGroups/idUsuario'

import * as AsientoContableService from 'services/asientosContables.service'
import * as TurnoService from 'services/turno.service'

import { MovimientosTurnoModal } from 'sharedComponents/modals'

const portletBreadcrumbs = [{ name: 'Turnos' }]

const TurnosPage = ({ history }) => {
  const __zariContext = React.useContext(ZariContext)

  const tablaRef = React.useRef(null)

  const [mostrarMovimientosModal, setMostrarMovimientosModal] = React.useState(false)
  const [idSeleccionado, setIdSeleccionado] = React.useState('')
  const [fechaFiltro, setFechaFiltro] = React.useState('')
  const [idUsuario, setIdUsuario] = React.useState('')

  React.useEffect(() => {
    const nuevaFecha = DateHandler.format(new Date())
    setFechaFiltro(nuevaFecha)
  }, [])

  const clickBuscarHandler = () => {
    if (!idUsuario) {
      __zariContext.snack('error', 'Seleccionar usuario')
      return
    }

    tablaRef.current.reload({
      idUsuario: idUsuario,
      fechaFiltro: fechaFiltro
    })
  }

  const clickImprimirReportePdfHandler = React.useCallback(
    id => {
      __zariContext.loader.open('Descargando PDF de cierre de turno...')

      TurnoService.descargarTicketCierrexId(id)
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          __zariContext.loader.close()
        })
    },
    [__zariContext]
  )

  const clickImprimirReporteCaja = React.useCallback(
    id => {
      __zariContext.loader.open('Descargando PDF de cierre de turno...')

      AsientoContableService.descargarPdfCajaxTurno(id)
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
        })
        .catch(err => {
          console.log(err)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          __zariContext.loader.close()
        })
    },
    [__zariContext]
  )

  const clickMostrarModalMovimientos = React.useCallback(id => {
    setIdSeleccionado(id)
    setMostrarMovimientosModal(true)
  }, [])

  return (
    <>
      <Portlet>
        <Portlet.Header title='Turnos' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Row className='p-3'>
            <Col md={3}>
              <FechaFiltroFormGroup value={fechaFiltro} onChange={e => setFechaFiltro(e.target.value)} />
            </Col>
            <Col md={2}>
              <IdUsuarioFormGroup value={idUsuario} onChange={e => setIdUsuario(e.target.value)} />
            </Col>
            <Col md={3}>
              <Button className='ml-2' onClick={clickBuscarHandler}>
                Buscar
              </Button>
            </Col>
          </Row>
          <Table.ServerSide
            preventFirstRender
            ref={tablaRef}
            useNest={true}
            baseParams={{
              tipoConsulta: 'filtro-x-usuario-x-fecha',
              usuario: idUsuario,
              fecha: fechaFiltro
            }}
            url='/turnos'
            headRows={[
              { label: 'FEC. INICIAL' },
              { label: 'FEC. FINAL' },
              { label: 'FALTANTE/SOBRANTE' },
              { label: 'USUARIO' },
              { label: 'ESTADO' },
              { label: '' }
            ]}
            rowTemplate={row => (
              <Table.Row hover key={row._id}>
                <Table.Cell>{row.fechaInicio || '--'}</Table.Cell>
                <Table.Cell>{row.fechaFin || '--'}</Table.Cell>
                <Table.Cell>{row.montoFaltanteSobrante || '--'}</Table.Cell>
                <Table.Cell>{row.username || '--'}</Table.Cell>
                <Table.Cell>{row.estado ? EstadosTurnosConstant.__dictionary[row.estado].nombre : '--'}</Table.Cell>
                <Table.Cell>
                  <Table.Dropdown>
                    {({ handleClose }) => [
                      <Table.Dropdown.Item
                        key='imprimirPdf'
                        handleClose={handleClose}
                        onClick={e => clickImprimirReportePdfHandler(row._id)}
                      >
                        Imprimir Ticket
                      </Table.Dropdown.Item>,
                      <Table.Dropdown.Item
                        key='imprimirPdf'
                        handleClose={handleClose}
                        onClick={e => clickImprimirReporteCaja(row._id)}
                      >
                        Imprimir Reporte Caja
                      </Table.Dropdown.Item>,
                      <Table.Dropdown.Item
                        key='modalMovimientos'
                        handleClose={handleClose}
                        onClick={e => clickMostrarModalMovimientos(row._id)}
                      >
                        Ver Detalles
                      </Table.Dropdown.Item>
                    ]}
                  </Table.Dropdown>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
      {mostrarMovimientosModal && (
        <MovimientosTurnoModal
          show={mostrarMovimientosModal}
          handleClose={() => {
            setMostrarMovimientosModal(false)
          }}
          id={idSeleccionado}
        />
      )}
    </>
  )
}

export default TurnosPage
